<template>
  <div>
    <b-card no-body class="mt-3">
      <template v-slot:header>
        <h5 class="mb-0">Stempeln</h5>
      </template>

      <b-list-group flush>
        <!-- row1 -->
        <b-list-group-item variant="light">
          <b-row align-v="center">
            <b-col class="ml--2">
              <span class="mb-0"> Stempelkosten pro Monat</span>
            </b-col>
            <b-col md="auto">
              <b-input-group class="input-group-merge">
                <b-form-input
                  type="text"
                  style="text-align:right;"
                  :disabled="true"
                  v-model="row1value"
                  onFocus="this.select()"
                  lazy
                />

                <b-input-group-append is-text>
                  <b-icon icon="cash-stack"></b-icon>
                </b-input-group-append>
              </b-input-group> </b-col></b-row
        ></b-list-group-item>
        <!-- row2 -->
        <b-list-group-item variant="light">
          <b-row align-v="center">
            <b-col class="ml--2">
              <span class="mb-0"> Stempelkosten pro Beleg</span>
            </b-col>
            <b-col md="auto">
              <b-input-group class="input-group-merge">
                <b-form-input
                  type="text"
                  style="text-align:right;"
                  :disabled="true"
                  v-model="row2value"
                  onFocus="this.select()"
                  lazy
                />

                <b-input-group-append is-text>
                  <b-icon icon="cash"></b-icon>
                </b-input-group-append>
              </b-input-group> </b-col></b-row
        ></b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "StempelCard",
  props: ["input"],
  data() {
    return {
      row1: null
    };
  },
  methods: {
    //Methode die einen Währungsstring in eine normale Number umwandelt (z.B: 1.540,30 € -> 1540.3)
    realParseFloat(s) {
      if (s == "" || s == null) {
        s = "0";
      }
      s = s.replace(/[^\d,.-]/g, ""); // strip everything except numbers, dots, commas and negative sign
      if (
        navigator.language.substring(0, 2) !== "de" &&
        /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(s)
      ) {
        // if not in German locale and matches #,###.######
        s = s.replace(/,/g, ""); // strip out commas
        return parseFloat(s); // convert to number
      } else if (/^-?(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d+)?$/.test(s)) {
        // either in German locale or not match #,###.###### and now matches #.###,########
        s = s.replace(/\./g, ""); // strip out dots
        s = s.replace(/,/g, "."); // replace comma with dot
        return parseFloat(s);
      } // try #,###.###### anyway
      else {
        s = s.replace(/,/g, ""); // strip out commas
        return parseFloat(s); // convert to number
      }
    },
    rowFormating(rowFormat, stateObj) {
      if (rowFormat == "currency") {
        //formatiert ins local Währungsformat inkl€
        return stateObj.toLocaleString("de-DE", {
          style: "currency",
          currency: "EUR"
        });
      } else if (rowFormat == "time") {
        //TODO falls es ander formatierungen geben soll
        return stateObj + " Minuten";
      } else if (!rowFormat) {
        //formatiert in lokale Dezimalschreibweise (. -> ,)
        return stateObj.toLocaleString("de-DE");
      }
    },
    gettersToLocaleCurrency(value) {
      return this.$store.getters[value].toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
      });
    }
  },
  computed: {
    row1value() {
      return this.$store.getters[
        "Rezeptmanagment/stempelKosten"
      ].toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
      });

      // this.gettersToLocaleCurrency(
      //   this.$store.getters["Rezeptmanagment/stempelKosten"]
      // );
    },
    row2value() {
      return this.$store.getters[
        "Rezeptmanagment/stempelKostenBeleg"
      ].toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
      });
    }
  }
};
</script>
